import React from 'react';
import { Link } from 'react-router-dom';

import {
  SuggestionsContainer,
  SuggestionsList,
  SuggestionsItem
} from './SearchSuggestions.styles';

const SearchSuggestions = ({ results, clearForm, setSearchOpen }) => {
  const handleClick = () => {
    clearForm('');
    setSearchOpen(false);
  };
  return (
    <SuggestionsContainer>
      <SuggestionsList>
        {results.map(result => (
          <SuggestionsItem key={result.id}>
            {
              <Link
                to={`/podcast/${result.id}`}
                className="dark-link"
                onClick={handleClick}
              >
                <img src={result.thumbnail} alt="Thumbnail of podcast" />
                <div>
                  <h3>{result.title_original}</h3>
                  <p>{result.publisher_original}</p>
                </div>
              </Link>
            }
          </SuggestionsItem>
        ))}
      </SuggestionsList>
    </SuggestionsContainer>
  );
};

export default SearchSuggestions;
